module.exports = __webpack_public_path__ + "static/media/home_TAA.d89f659f.jpg";